export default "__VITE_ASSET__cefddb91__"